export default __webpack_public_path__ + "static/media/1177.9399a660.png";